// @flow
import * as React from "react";
import range from "lodash/range";

import styles from "./EmptyColumns.scss";

type EmptyColumnsProps = {
  amountOfEmptyColumns: number
};

const EmptyColumns = ({ amountOfEmptyColumns }: EmptyColumnsProps): React.Node =>
  range(amountOfEmptyColumns).map(optionIndex => (
    <div className={styles.empty} key={optionIndex} />
  ));

export default EmptyColumns;
